export default __webpack_public_path__ + "static/media/f_ancor.4a00d3dc.svg";